import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { BirthdateInput } from '../../../BasePersonInputs/Birthdate/BirthdateInput';

export function BirthdateField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={BirthdateInput}
      label='Geburtstag'
    />
  );
}
